import React from 'react';
import { Button } from '@avila-tek/ui/src';
import {
  ApolloQueryResult,
  OperationVariables,
  useMutation,
} from '@apollo/client';
import { DocumentForm } from '../shared';
import { Company, DocumentModel } from '../../models';
import { UPLOAD_COMPANY_GOAL } from '../../graphql/mutation';
import { useNotify, useUser } from '../../hooks';

interface UploadGoalsProps {
  refetch: (variables?: Partial<OperationVariables>) => Promise<
    ApolloQueryResult<{
      company: Company;
    }>
  >;
}
function UploadGoals({ refetch }: UploadGoalsProps) {
  const notify = useNotify();
  const [user] = useUser();

  const [documents, setDocuments] = React.useState<
    Array<Partial<DocumentModel>>
  >([]);

  const [uploadCompanyGoals, { loading }] = useMutation<{
    uploadCompanyGoals: { _id: string };
  }>(UPLOAD_COMPANY_GOAL);

  const uploadCompanyGoalsDocument = async (
    e: React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => {
    e.preventDefault();
    if (!documents[0].src) {
      notify('Por favor, selecciona un archivo', 'error');
      return;
    }
    try {
      const { data } = await uploadCompanyGoals({
        variables: {
          data: {
            companyId: (user?.company as Company)._id,
            url: documents[0].src as string,
          },
        },
      });
      if (data?.uploadCompanyGoals?._id) {
        notify('Metas cargadas con éxito', 'success');
        setDocuments([]);
        refetch();
      } else {
        notify(
          'Ha ocurrido un error al cargar las metas, por favor intenta de nuevo',
          'error'
        );
      }
    } catch (error) {
      notify(error.message, 'error');
    }
  };

  return (
    <section className="space-y-5">
      <DocumentForm
        documents={documents}
        updateURLs={setDocuments}
        maximumAmount={1}
        title="Excel de Metas"
        documentType={{
          'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet': [
            '.xlsx',
          ],
          'application/vnd.ms-excel': ['.xls'],
        }}
        documentFormat="https://avilatek.sfo3.digitaloceanspaces.com/images/Formato_Meta_Meit.xlsx"
      />
      {documents.length > 0 ? (
        <div className="flex md:w-1/3 ml-auto">
          <Button disabled={loading} onClick={uploadCompanyGoalsDocument}>
            {!loading ? 'Cargar metas' : 'Cargando metas...'}
          </Button>
        </div>
      ) : null}
    </section>
  );
}

export default UploadGoals;
